var files = false;
$( document ).ready(function() {
	files = new cFiles();
});

function cFiles(){
	var self = this;
	//Only run on /clients/ pages.
	if(window.location.href.indexOf("/files/") > -1) {
       this.onload('files');
   }else if (window.location.href.indexOf("/orders/") > -1){
	   this.onload('orders');
   }
}

cFiles.prototype.onload = function(returnURL){

	$('.file-delete').click(function(returnURL){
		if(!confirm('Are you sure you want to delete this file? The file cannot be recovered later.')){
			return;
		}
		id = $(this).data('id');
		csrf = $('[name="csrf-token"]').attr('content');
		returnURLinput = returnURL == '/files/' ? '<input type="hidden" name="returnurl" value="">' : '<input type="hidden" name="returnurl" value="' + window.location.href + '">';
		$('<form action="/files/' + id + '" method="post"><input name="_method" type="hidden" value="DELETE"><input name="_token" type="hidden" value="' + csrf + '">' + returnURLinput + '</form>').appendTo('body').submit();
	});
}
